import { dice } from 'ionicons/icons';
import { NamedOperation } from 'operationlib';

const diceSvg = dice.slice(dice.indexOf(',') + 1);

function escapeHtml(s: string): string {
  return s.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
}

function escapeAttr(s: string): string {
  return escapeHtml(s).replaceAll('"', '&quot;');
}

/**
 * HTML span for a roll in chat (same shape as TinyMCE operation insert).
 */
export function buildOperationChatSpan(
  named: NamedOperation,
  characterId: number | string,
  characterName?: string
): string {
  const op = escapeAttr(named.operation ?? '');
  const opNameAttr = escapeAttr(named.name ?? '');
  const opNameHtml = escapeHtml(named.name ?? '');
  const compiled = escapeAttr(named.compiledOperation ?? '');
  const selected = escapeAttr(named.withStatOperation ?? '');
  const charId = String(characterId ?? '');
  const charPart =
    characterName && characterName.length > 0
      ? `<em class="op-chip__char">${escapeHtml(characterName)}</em>`
      : '';
  /* &#8203; keeps .result non-empty so TinyMCE/serializers are less likely to drop it */
  return `&nbsp;<span data-operation="${op}" data-operation-name="${opNameAttr}" data-operation-stat-compiled="${compiled}" data-operation-stat-selected="${selected}" data-character="${escapeAttr(charId)}" contentEditable="false">${diceSvg}<span class="op-chip__body"><strong class="op-chip__name">${opNameHtml}</strong>${charPart}</span><strong class="result">&#8203;</strong></span>&nbsp;`;
}
